import { FILE_REF_KEYS, type FileRef } from '@/types/file';

/**
 * Whether two FileRefs are the same file as far as the client can tell
 * (#885a-1, #885a-4). The wire FileRef carries no id, so the whole value
 * stands in for one: every FileRef field compared, in any key order, with an
 * absent field equal to `null`. `null` and `undefined` both mean "no file" and
 * equal each other.
 *
 * The ONE place the client decides "this read is the ref a save replaced":
 * AvatarEditor's stale-read exception and `useUnconfirmedSave` both use it.
 */
export function sameFileRef(
  a: FileRef | null | undefined,
  b: FileRef | null | undefined,
): boolean {
  if (!a || !b) return !a && !b;
  return (Object.keys(FILE_REF_KEYS) as (keyof FileRef)[]).every(
    (key) => (a[key] ?? null) === (b[key] ?? null),
  );
}
